export class StatusProperties {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "statusMessageKey",
            "baseName": "statusMessageKey",
            "type": "string",
            "format": ""
        },
        {
            "name": "statusMessage",
            "baseName": "statusMessage",
            "type": "string",
            "format": ""
        },
        {
            "name": "blockers",
            "baseName": "blockers",
            "type": "Array<ResourceBlockerDetail>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return StatusProperties.attributeTypeMap;
    }
    constructor() {
    }
}
